<template>
    <div v-if="isVisibleProgressBar" class="progress-bar">
        <img
            v-if="!isOandaPath"
            class="image"
            src="@/assets/time-to-finish.png"
            alt="time to finish onboarding"
        />
        <img
            v-if="isOandaPath"
            class="image"
            src="@/assets/time.svg"
            alt="time to finish onboarding"
        />
        <div class="row">
            {{ $t(`${TRANSLATION_KEY}.toFinish`) }}
            <br />
            <span class="time-to-finish">
                {{ timeToFinish }}
                <span>
                    {{ $t(`${TRANSLATION_KEY}.${adjustTextProgressBar()}`) }}
                </span>
            </span>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, computed, reactive } from 'vue';
import { useStore } from 'vuex';
import { UtilityHelper } from '@/helpers/UtilityHelper';

export default defineComponent({
    name: 'ProgressBar',
    setup() {
        const state = reactive({
            isVisibleProgressBar: true,
            TRANSLATION_KEY: 'ProgressBar',
        });

        const store = useStore();

        const isOandaPath = computed(() => UtilityHelper.isOandaPath());

        const timeToFinish = computed(() => store.state.timeToFinish);

        const adjustTextProgressBar = (): string => {
            if (timeToFinish.value >= 5 || timeToFinish.value === 0) {
                return 'minute';
            } else if (timeToFinish.value === 1) {
                return 'singularMinute';
            } else {
                return 'minutes';
            }
        };

        return {
            isVisibleProgressBar: state.isVisibleProgressBar,
            TRANSLATION_KEY: state.TRANSLATION_KEY,
            isOandaPath,
            timeToFinish,
            adjustTextProgressBar,
        };
    },
});
</script>
